var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetitorDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9978 8.35594C20.9278 8.34427 20.8461 8.34427 20.7761 8.35594C19.1661 8.29761 17.8828 6.97927 17.8828 5.34594C17.8828 3.67761 19.2245 2.33594 20.8928 2.33594C22.5611 2.33594 23.9028 3.68927 23.9028 5.34594C23.8911 6.97927 22.6078 8.29761 20.9978 8.35594Z",
    stroke: "#252525",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7967 16.8495C21.3951 17.1178 23.1567 16.8378 24.3934 16.0095C26.0384 14.9128 26.0384 13.1161 24.3934 12.0195C23.1451 11.1911 21.3601 10.9111 19.7617 11.1911",
    stroke: "#252525",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9675 8.35594C7.0375 8.34427 7.11917 8.34427 7.18917 8.35594C8.79917 8.29761 10.0825 6.97927 10.0825 5.34594C10.0825 3.67761 8.74084 2.33594 7.0725 2.33594C5.40417 2.33594 4.0625 3.68927 4.0625 5.34594C4.07417 6.97927 5.3575 8.29761 6.9675 8.35594Z",
    stroke: "#252525",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17026 16.8495C6.57193 17.1178 4.81026 16.8378 3.57359 16.0095C1.92859 14.9128 1.92859 13.1161 3.57359 12.0195C4.82193 11.1911 6.60692 10.9111 8.20526 11.1911",
    stroke: "#252525",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9939 17.0669C13.9239 17.0552 13.8422 17.0552 13.7722 17.0669C12.1622 17.0085 10.8789 15.6902 10.8789 14.0569C10.8789 12.3885 12.2206 11.0469 13.8889 11.0469C15.5572 11.0469 16.8989 12.4002 16.8989 14.0569C16.8872 15.6902 15.6039 17.0202 13.9939 17.0669Z",
    stroke: "#252525",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6009 20.7439C8.95594 21.8406 8.95594 23.6372 10.6009 24.7339C12.4676 25.9822 15.5243 25.9822 17.3909 24.7339C19.0359 23.6372 19.0359 21.8406 17.3909 20.7439C15.5359 19.5072 12.4676 19.5072 10.6009 20.7439Z",
    stroke: "#252525",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitorDatabase);
export default __webpack_public_path__ + "static/media/Competitor-Database.6d6f5e0a3565309f0a2f21a64f46437e.svg";
export { ForwardRef as ReactComponent };